export default __webpack_public_path__ + "static/media/dipSwitch.cb9fb677.png";